import { makeStyles } from "@material-ui/core";
import { useEditor } from "@tldraw/tldraw";
import { If } from "components/logic";
import { useCallback, useState } from "react";
import PrintRuleModal from "../PrintRuleModal/PrintRuleModal";
import Aside from "./Aside";
import Toolbar from "./Toolbar/NewToolBar";

const SideBar = ({
  loading,
  setIdFromat,
  setIsShowCustomStylePanel,
  store,
  selectedSection,
  setSelectedSection,
  setIsShowSidebar,
  isShowSidebar,
}) => {
  const [isShowPrintRuleModal, setIsShowPrintRuleModal] = useState(false);
  const classes = useStyles();

  const handleOpenPrintRuleModal = useCallback(() => {
    setIsShowPrintRuleModal(true);
  }, []);

  const handleClosePrintRuleModal = useCallback(() => {
    setIsShowPrintRuleModal(false);
  }, []);

  return (
    <div className={classes.root}>
      <Toolbar
        store={store}
        handleOpenPrintRuleModal={handleOpenPrintRuleModal}
        selectedSection={selectedSection}
        setSelectedSection={setSelectedSection}
      />
      <If condition={!!selectedSection}>
        <Aside
          loading={loading}
          selectedSection={selectedSection}
          setIdFromat={setIdFromat}
          setIsShowCustomStylePanel={setIsShowCustomStylePanel}
          isShowSidebar={isShowSidebar}
          setIsShowSidebar={setIsShowSidebar}
        />
      </If>
      <If condition={isShowPrintRuleModal}>
        <PrintRuleModal onCancel={handleClosePrintRuleModal} />
      </If>
    </div>
  );
};

export default SideBar;

const useStyles = makeStyles({
  root: {
    paddingTop: 80,
    zIndex: 10,
    display: "flex",
    alignItems: "stretch",
    height: "100%",
    flex: 1,
    position: "relative",
    width: "min-content",
  },
});
